/** Copy ganti perangkat — acuan: superoti/docs/06-specs/kitchen-delman-device-lifecycle.md §8 */

export const SWITCH_DEVICE_LABEL = 'Ganti perangkat'

export const SWITCH_DEVICE_HINT =
  'Data lokal akan dihapus. Wajib minta Admin HO unbind perangkat ini sebelum aktivasi pengganti. Setelah reset, masukkan kode aktivasi baru dari HO.'

export const SWITCH_DEVICE_DIALOG = {
  title: 'Ganti perangkat?',
  message:
    'Data lokal akan dihapus. Wajib minta Admin HO unbind perangkat ini sebelum aktivasi pengganti.\n\nSetelah reset, masukkan kode aktivasi baru dari HO.',
  confirm: 'Reset & aktivasi ulang',
  cancel: 'Batal',
} as const
